export enum SortDirection {
  None = '',
  Ascending = 'ASC',
  Descending = 'DESC'
}
